

























import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component
export default class ConfirmModal extends Vue {
  @Prop({ default: true })
  showCancel: boolean

  get headerVisibility(): boolean {
    return !!this.$slots.header
  }

  @Emit('ok')
  emitOk() {
    // Do nothing
  }

  @Emit('cancel')
  emitCancel() {
    // Do nothing
  }

}
